/**
 * Dependencies.
 */
import { BaseModel, endpoint } from '@prz-dp/services';

import DeliveryModel from '@/api/delivery/delivery.model';
import DriverModel from '@/api/driver/driver.model';

/**
 * Model `DeliverySurveyModel`.
 */
@endpoint('deliverySurvey')
export default class DeliverySurveyModel extends BaseModel {
  /**
   * Properties.
   */
  alreadySubmited: boolean;

  assignedPoints: number;

  availablePoints: number;

  classification: number;

  comments?: {
    other?: string;

    type: string;
  };

  delivery: DeliveryModel;

  driver: DriverModel;

  entityComments?: {
    other?: string;

    type: string;
  };

  user?: {
    id: number;

    name: string;
  };

  vehicle?: {
    photo?: {
      encodedFileContent: string;

      mediaType: string;
    };

    photoLink?: string;
  };

  /**
   * Constructor.
   */
  constructor(data: Partial<DeliverySurveyModel>) {
    super(data);
  }
}
